import React from 'react';
import { RiArrowGoBackLine } from 'react-icons/ri';
import { usePreferences } from '../../contexts/PreferencesContext';

const ModuleTabChooser = ({ activeTab, modules = [], onSelect, onBack }) => {
  const { t } = usePreferences();
  const visibleModules = modules.filter(Boolean);
  const activeModule = visibleModules.find((module) => module.id === activeTab);

  if (activeTab === -1 || activeModule == null) {
    return (
      <section className="modules-container module-tab-chooser">
        <h5 className="section-title">{t('chooseOption')}</h5>
        <div className="modules-grid">
          {visibleModules.map((module) => (
            <button type="button" key={module.id} className="module-card" onClick={() => onSelect(module.id)}>
              <span className="module-icon" aria-hidden="true">{module.icon}</span>
              <span className="module-copy">
                <strong>{module.title}</strong>
                {module.description && <small>{module.description}</small>}
              </span>
            </button>
          ))}
        </div>
      </section>
    );
  }

  return (
    <div className="module-tab-active-header">
      <button type="button" className="btn-back-modern" onClick={onBack}>
        <RiArrowGoBackLine />
        <span>{t('action_back')}</span>
      </button>
      <div>
        <span>{t('viewing')}</span>
        <strong>{activeModule.title}</strong>
      </div>
    </div>
  );
};

export default ModuleTabChooser;
